import {post,} from '../utils'

export default host => (shortLink, to) =>
    post(
        `${host}/share_links/${shortLink}`,
        JSON.stringify({
            to: to
        }))
        .then(response => response.json())
        .then(json => json.data);